/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {NbButtonModule, NbCardModule, NbInputModule, NbSpinnerModule, NbWindowRef} from '@nebular/theme';
import {BaseComponent, InputFile, SuggestIdea, UploaderComponent} from 'compob2b-libs';
import {take} from 'rxjs/operators';
import {NgIf} from '@angular/common'

@Component({
  templateUrl: './modal-suggest-idea.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    NbCardModule,
    UploaderComponent,
    NbInputModule,
    NgIf,
    ReactiveFormsModule,
    NbButtonModule,
    NbSpinnerModule
  ]
})
export class ModalSuggestIdeaComponent extends BaseComponent {
  submitted = false;

  accept = '.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif';
  allowedMimeTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ];

  suggestForm = new UntypedFormGroup({
    name: new UntypedFormControl(''),
    fileInput: new UntypedFormControl(null),
    email: new UntypedFormControl('', [
      Validators.email,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ]),
    text: new UntypedFormControl('', Validators.required)
  });

  constructor(private readonly window: NbWindowRef) {
    super();
  }

  onUpload(files: InputFile[]) {
    this.suggestForm.controls.fileInput.patchValue(files[0].file);
  }

  onSubmit(): void {
    this.submitted = true;
    this.compoApiService.postForm<SuggestIdea, string>('/suggest-idea', this.suggestForm.value).pipe(take(1)).subscribe(
      response => {
        if (response.success) {
          this.successToast('Обращение отправлено администратору. Мы обязательно ваше предложение. Спасибо!');
          this.close();
        } else {
          this.errorToast('Возникла ошибка');
        }
        this.submitted = false;
        this.cdr.detectChanges();
      });
  }

  close() {
    this.window.close();
  }

}
